/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection12FoiChanged, m11ReportSection12ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection12Foi, selectM11ReportSection12Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveSupportingDetailsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section12State, setAlertModalState, setStartingSection12State) => {

  let changesStates = {
    section12State: section12State
  };
  let response = await saveM11Changes(apiToken, 41, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection12Resource) {
      dispatch(m11ReportSection12ResourceChanged(response.m11ReportSection12Resource));
    }
    setStartingSection12State(JSON.parse(JSON.stringify(section12State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step041SupportingDetailsPart1 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection12Foi = useSelector(selectM11ReportSection12Foi);
  const m11ReportSection12Resource = useSelector(selectM11ReportSection12Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section12State, setSection12State] = useState({
    "section121Status": "empty", "section121Xhtml": "",
    "section122Status": "empty", "section122Xhtml": ""
  });
  const [startingSection12State, setStartingSection12State] = useState({
    "section121Status": "empty", "section121Xhtml": "",
    "section122Status": "empty", "section122Xhtml": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section12State, startingSection12State)),
    async saveAllChanges() {
      await saveSupportingDetailsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section12State, setAlertModalState, setStartingSection12State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section121Status": "empty", "section121Xhtml": "",
        "section122Status": "empty", "section122Xhtml": "",
        "loaded": true
      };
      setSection12State(startingData);
      setStartingSection12State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[12]?.entry?.length) {
        let m11ReportSection012Foi = getIdFromReference(m11ReportContainerResource.section[12].entry[0]);
        if (m11ReportSection012Foi && !isNaN(m11ReportSection012Foi) && m11ReportSection012Foi !== m11ReportSection12Foi) {
          dispatch(m11ReportSection12FoiChanged(m11ReportSection012Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection12Foi && !isNaN(m11ReportSection12Foi)) {
      loadResource(m11ReportSection12Foi, "M11ReportSection12", apiToken, dispatch);
    }
  }, [m11ReportSection12Foi]);

  useEffect(() => {
    if (m11ReportSection12Resource && Object.keys(m11ReportSection12Resource).length > 0) {
      let startingData = {
        "section121Status": "empty", "section121Xhtml": "",
        "section122Status": "empty", "section122Xhtml": "",
        "loaded": true
      };
      if (m11ReportSection12Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection12Resource.section[0].section[0]?.text?.div &&
          m11ReportSection12Resource.section[0].section[0].text.status !== "empty") {
          startingData.section121Status = m11ReportSection12Resource.section[0].section[0].text.status;
          startingData.section121Xhtml = m11ReportSection12Resource.section[0].section[0].text.div;
        }
        if (m11ReportSection12Resource.section[0].section[1]?.text?.div &&
          m11ReportSection12Resource.section[0].section[1].text.status !== "empty") {
          startingData.section122Status = m11ReportSection12Resource.section[0].section[1].text.status;
          startingData.section122Xhtml = m11ReportSection12Resource.section[0].section[1].text.div;
        }
        setSection12State(startingData);
        setStartingSection12State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection12Resource]);

  return <div>
    <h3>Start Section 12 Supporting Details</h3>
    {!(m11ReportSection12Resource?.id || m11ReportContainerResource?.id) &&
      <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
    }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 41 (Start Section 12 Supporting Details) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section12State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 12.1 Clinical Laboratory Tests as needed.</h4>
          <TextDivEntry elementName="section121Xhtml"
            startingValue={section12State.section121Xhtml}
            setResourceState={setSection12State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 12.2 Country/Region-Specific Differences as needed.</h4>
          <TextDivEntry elementName="section122Xhtml"
            startingValue={section12State.section122Xhtml}
            setResourceState={setSection12State} />
        </>}
      </>
    }
  </div >
});

const M11Step041SupportingDetailsPart1HelperText = <div>
  <h3>Start Section 12 Supporting Details</h3>
  <div style={{ textAlign: "left" }}>
    <p>Enter data for Section 12.1 Clinical Laboratory Tests.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Specify which laboratory parameters should be included in each clinical laboratory assessment panel (e.g., haematology, chemistry, urinalysis). A tabular presentation for such information is common. If applicable, include equations and references for locally calculated laboratory results.</p>
      <p>If not applicable, retain heading and enter “Not applicable.”</p>
    </div>
    <p>Enter data for Section 12.2 Country/Region-Specific Differences.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Although global clinical trial practices are increasingly harmonised, some country/region-specific differences in requirements do exist (e.g., document retention periods, contraception requirements). Where differences in requirements cannot be reconciled, the sponsor should explain how country/region-specific differences will be documented and communicated (e.g., by country/region-specific amendments or addenda).</p>
      <p>An alternative to country/region-specific amendments is to list the specific differences by country or countries in this section, including a reference to the relevant section of the protocol where each differing requirement applies.</p>
      <p>If not applicable, retain the heading and enter “Not applicable.”</p>
    </div>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step041SupportingDetailsPart1ValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 41, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 41 (Start Section 12 Supporting Details) {validationCheckState.step41numberOfChecks} issues checked. {validationCheckState.step41numberPassed} passed. {validationCheckState.step41numberFailed} failed.</h4>
    <p>Section 12 heading is 'APPENDIX: SUPPORTING DETAILS': {validationCheckState.resultCheckSection12Heading}</p>
    <p>Section 12 APPENDIX: SUPPORTING DETAILS does not have text: {validationCheckState.resultCheckSection12Content}</p>
    <p>Section 12.1 heading is 'Clinical Laboratory Tests': {validationCheckState.resultCheckSection121Heading}</p>
    <p>Section 12.1 Clinical Laboratory Tests has content: {validationCheckState.resultCheckSection121Content}</p>
    <p>Section 12.2 heading is 'Country/Region-Specific Differences': {validationCheckState.resultCheckSection122Heading}</p>
    <p>Section 12.2 Country/Region-Specific Differences has content: {validationCheckState.resultCheckSection122Content}</p>
  </div>}  </div>
}

export default M11Step041SupportingDetailsPart1;
export { M11Step041SupportingDetailsPart1HelperText, M11Step041SupportingDetailsPart1ValidationCheck };